import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConfigurationService } from '@shared/services/global-configuration.service';
import { PublicSettings } from '@shared/view-model/public-settings.model';
import { OAuthService } from 'angular-oauth2-oidc';
import { defer, from, Observable, of } from 'rxjs';
import { map, share, switchMap, tap } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class SettingsService {
    public token: string;
    public decoded_token: any;
    private user: any;
    public app: any;
    public layout: any;
    doc: any;
    userProfileObservable: Observable<object>;
    loadDiscoveryDocumentAndTryLoginObservable: Observable<any>;

    constructor(
        private oauthService: OAuthService,
        private router: Router) {

        // App Settings
        // -----------------------------------
        this.app = {
            name: "FormBuilder",
            description: "User Management UI",
            year: ((new Date()).getFullYear()),
            docLoaded: false,
            version: "1.0"
        };
        this.layout = {
            isCollapsed: true
        };
        this.userProfileObservable = defer(() => from(this.oauthService.loadUserProfile())).pipe(share());
        this.loadDiscoveryDocumentAndTryLoginObservable = defer(() => from(this.oauthService.loadDiscoveryDocument())).pipe(share()).pipe(tap(a => this.doc = a)).pipe(switchMap(a => this.oauthService.tryLogin())).pipe(map(() => this.doc));
    }


    public getUserProfile(): Observable<object> {
        if (this.user == null) {
            return this.userProfileObservable;
        }
        return of(this.user);
    }

    set userpicture(image: string) {
        this.user.picture = image;
    }

    getRole() {
        this.token = localStorage.getItem('access_token');
        let decoded:any = this.getDecodedAccessToken(this.token)
        return decoded.role;
    }
    getDecodedAccessToken(token: string): any {
        try{
            return jwt_decode(token);
        }
        catch(Error){
            return null;
        }
      }
}